import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../components/common/Button';

const Promotion: React.FC = () => {
  const plans = [
    {
      name: 'Most Popular',
      price: 10,
      period: 'Monthly',
      features: [
        'Verified artist badge',
        'Priority in search',
        'Featured on homepage',
        'Advanced analytics',
        'Custom URL',
        'Priority support'
      ]
    },
    {
      name: 'All-in Plus',
      price: 10,
      period: 'Annual',
      features: [
        'Grow, Connect, and Earn as an Artist with ANI',
        'All Monthly features',
        '2 months free',
        'Exclusive workshops',
        'Early access to new features'
      ]
    }
  ];

  return (
    <div className="p-4 pb-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Flexible pricing built for</h1>
      <h2 className="text-2xl font-bold text-primary mb-6">every business need</h2>

      <div className="flex justify-center gap-2 mb-8">
        <button className="px-6 py-2 bg-white border-2 border-primary text-primary rounded-full font-medium">
          Monthly
        </button>
        <button className="px-6 py-2 bg-gray-100 text-gray-600 rounded-full font-medium">
          Annual
        </button>
      </div>

      <div className="space-y-6">
        {plans.map((plan, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-lg p-6 border-2 border-gray-200 hover:border-primary transition-colors">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-800">{plan.name}</h3>
                <div className="flex items-baseline gap-1 mt-2">
                  <span className="text-3xl font-bold text-primary">${plan.price}</span>
                  <span className="text-gray-500">/ {plan.period}</span>
                </div>
              </div>
              {index === 0 && (
                <span className="bg-primary text-white text-xs px-3 py-1 rounded-full">
                  Most Popular
                </span>
              )}
            </div>

            <ul className="space-y-3 mb-6">
              {plan.features.map((feature, i) => (
                <li key={i} className="flex items-start gap-2">
                  <Check size={20} className="text-green-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>

            <Button fullWidth>
              Subscribe Now
            </Button>
          </div>
        ))}
      </div>

      <div className="mt-8 bg-gradient-to-r from-primary to-secondary rounded-2xl p-6 text-white text-center">
        <h3 className="text-xl font-bold mb-2">Need a custom plan?</h3>
        <p className="mb-4 opacity-90">Contact us for enterprise solutions</p>
        <button className="px-6 py-3 bg-white text-primary rounded-lg font-medium hover:bg-gray-100 transition-colors">
          Contact Sales
        </button>
      </div>
    </div>
  );
};

export default Promotion;